import { render, staticRenderFns } from "./UpdateTaskModal.vue?vue&type=template&id=08f2ba80&"
import script from "./UpdateTaskModal.vue?vue&type=script&lang=js&"
export * from "./UpdateTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports